import sanitize from 'sanitize-html';

/** Options shape for {@link sanitizeHtml} overrides (from sanitize-html). */
export type SanitizeHtmlOptions = NonNullable<Parameters<typeof sanitize>[1]>;

/**
 * Default rules: inline navigation links only (tenant/CMS copy with optional `<a>`).
 * Spread or replace via the second argument to `sanitizeHtml`.
 */
export const defaultSanitizeHtmlOptions: SanitizeHtmlOptions = {
  allowedTags: ['a'],
  allowedAttributes: { a: ['href', 'title', 'target', 'rel'] },
  allowedSchemes: ['http', 'https'],
  allowProtocolRelative: false,
  transformTags: {
    a: (_tag, attribs) => ({
      tagName: 'a',
      attribs: {
        ...attribs,
        ...(attribs.target === '_blank' ? { rel: 'noopener noreferrer' } : {}),
      },
    }),
  },
};

/**
 * Sanitizes an HTML string for safe `dangerouslySetInnerHTML` (or similar).
 * Merges {@link defaultSanitizeHtmlOptions} with `sanitizeHtmlOptions` (shallow): a supplied
 * `transformTags` or `allowedAttributes` replaces the default object for that key.
 */
export function sanitizeHtml(
  html: string,
  sanitizeHtmlOptions?: SanitizeHtmlOptions,
): string {
  return sanitize(html || '', {
    ...defaultSanitizeHtmlOptions,
    ...sanitizeHtmlOptions,
  });
}
